<template>
	<svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_10_11664)">
			<rect x="7" y="4" width="2" height="8" fill="#232533" />
			<path
				d="M8.72656 16.273H7.27202V15.5457H6.54474V14.8184H5.81747V14.0912H5.0902V13.3639H4.36293V12.6366H3.63565V11.9094H2.90838V11.1821H2.18111V10.4548H1.45384V9.72754H0.726562V8.27299H1.45384V7.54572H2.18111V6.81845H2.90838V6.09118H3.63565V5.3639H4.36293V4.63663H5.0902V3.90936H5.81747V3.18208H6.54474V2.45481H7.27202V1.72754H8.72656V2.45481H9.45384V3.18208H10.1811V3.90936H10.9084V4.63663H11.6357V5.3639H12.3629V6.09118H13.0902V6.81845H13.8175V7.54572H14.5447V8.27299H15.272V9.72754H14.5447V10.4548H13.8175V11.1821H13.0902V11.9094H12.3629V12.6366H11.6357V13.3639H10.9084V14.0912H10.1811V14.8184H9.45384V15.5457H8.72656V16.273ZM8.72656 9.72754V5.3639H7.27202V9.72754H8.72656ZM8.72656 12.6366V11.1821H7.27202V12.6366H8.72656Z"
				fill="black"
				fill-opacity="0.38"
			/>
			<path
				d="M8.72656 15.273H7.27202V14.5457H6.54474V13.8184H5.81747V13.0912H5.0902V12.3639H4.36293V11.6366H3.63565V10.9094H2.90838V10.1821H2.18111V9.45481H1.45384V8.72754H0.726562V7.27299H1.45384V6.54572H2.18111V5.81845H2.90838V5.09118H3.63565V4.3639H4.36293V3.63663H5.0902V2.90936H5.81747V2.18208H6.54474V1.45481H7.27202V0.727539H8.72656V1.45481H9.45384V2.18208H10.1811V2.90936H10.9084V3.63663H11.6357V4.3639H12.3629V5.09118H13.0902V5.81845H13.8175V6.54572H14.5447V7.27299H15.272V8.72754H14.5447V9.45481H13.8175V10.1821H13.0902V10.9094H12.3629V11.6366H11.6357V12.3639H10.9084V13.0912H10.1811V13.8184H9.45384V14.5457H8.72656V15.273ZM8.72656 8.72754V4.3639H7.27202V8.72754H8.72656ZM8.72656 11.6366V10.1821H7.27202V11.6366H8.72656Z"
				fill="#E87040"
			/>
		</g>
		<defs>
			<clipPath id="clip0_10_11664">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'

const props = withDefaults(
	defineProps<{
		size?: number
	}>(),
	{
		size: 16
	}
)

const { size } = toRefs(props)
</script>
